import { createSlice } from '@reduxjs/toolkit';

const websiteSlice = createSlice({
  name: 'websites',
  initialState: {
    attackList: [],
    selectedRows: [],
  },
  reducers: {
    addToAttackList: (state, action) => {
      const newRows = action.payload.filter(
        (newRow) => !state.attackList.some((existingRow) => existingRow.id === newRow.id)
      );
      state.attackList.push(...newRows);
    },
    removeFromAttackList: (state, action) => {
      state.attackList = state.attackList.filter((website) => website.id !== action.payload.id);
    },
    clearAttackList: (state) => {
      state.attackList = [];
      state.selectedRows = [];
    },
    updateSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
});

export const { addToAttackList, removeFromAttackList, clearAttackList, updateSelectedRows } = websiteSlice.actions;

export const selectAttackList = (state) => state.websites.attackList;
export const selectSelectedRows = (state) => state.websites.selectedRows;

export default websiteSlice.reducer;
